export default {
    data() {
        return {
            monthsShort: ["Janv.", "Févr.", "Mars", "Avr.", "Mai", "Juin", "Juil.", "Août", "Sept.", "Oct.", "Nov.", "Déc."],
            monthsLong: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
        }
    },
    methods: {
        getCoursEffectif: function (cours, destination, diff) {
            if(cours === ''){
              return '';
            }
            if (destination.coef) {
                // cours = (mais - base) * coef
                cours -= destination.base;
                cours *= destination.coef;
                cours = Math.round(cours);
            }
            if (diff === '') {
                cours += this.getDefaultDiff(destination);
            } else if (diff) {
                cours += diff;
            }
            return Math.round(cours * 100) / 100;
        },
        getCoursFromEffectif(cours, destination, diff) {
            if (cours === '') {
                return '';
            }
            if (diff === '') {
                cours -= this.getDefaultDiff(destination);
            } else if (diff) {
                cours -= diff;
            }
            if (destination.coef) {
                // cours = (mais - base) * coef
                cours /= destination.coef;
                cours += destination.base;
                cours = Math.round(cours);
            }
            return Math.round(cours * 100) / 100;
        },
        getDefaultDiff(destination) {
            var diff = 0;
            if (!destination.coef && destination.base) {
                diff -= destination.base;
            }
            if (destination.prime) {
                diff += destination.prime;
            }
            return diff;
        },
        getEcheanceList(coursName, campagne) {
            var echeanceList = [];
            if (this.referentiel.cours[coursName].echeances) {
                for (let i = 0; i < this.referentiel.cours[coursName].echeances.length; i++) {
                    let echeance = this.referentiel.cours[coursName].echeances[i];
                    echeance -= 1;
                    echeanceList.push(
                        (campagne + parseInt(echeance / 12)).toString()
                        + ((echeance % 12 < 9) ? '0' : '')
                        + (echeance % 12 + 1).toString()
                    );
                }
            }
            return echeanceList;
        },
        getEcheanceDefault(campagne, echeanceCurrent, echeanceList) {
          var echeanceDefault = campagne;
          if (echeanceList.length) {
            for (let i = 0; i < echeanceList.length; i++) {
              echeanceDefault = echeanceList[i];
              if (echeanceDefault >= echeanceCurrent) {
                break;
              }
            }
          } else if (echeanceDefault > echeanceCurrent) {
            // cours physique au max campagne en cours
            echeanceDefault = echeanceCurrent;
          }
          return echeanceDefault;
        },
        getCoursJour(coursName, coursData, live, echeanceList, echeanceDefault, isHideExpire) {
            var coursJour = {};
            if (echeanceList.length) {
                for (let i = 0; i < echeanceList.length; i++) {
                    const echeance = echeanceList[i];
                    if(isHideExpire && echeance < echeanceDefault){
                        continue;
                    }
                    coursJour[echeance] = this.getCoursJourInfos(coursName, echeance, coursData, live, echeance < coursData.current);
                }
                if(! (echeanceDefault < coursData.current)){
                  for (const cultCode in live) {
                      let itemCoursName = cultCode.split('_');
                      const echeance = itemCoursName.pop();
                      itemCoursName = itemCoursName.join('_');
                      if (itemCoursName != coursName) {
                          continue;
                      }
                      if (echeanceList.includes(echeance)) {
                          continue;
                      }
                      if (! coursData[echeance]){
                          continue;
                      }
                      coursJour[echeance] = this.getCoursJourInfos(coursName, echeance, coursData, live);
                  }
                }
            } else {
                coursJour[echeanceDefault] = null;
                var cours = coursData[echeanceDefault];
                if (cours) {
                  var coursLast = cours[cours.length - 1];
                  var coursLastVal = Math.round(coursLast[1] * 100) / 100; // Math.round pour le soja
                  var cousDiffVal = coursLastVal - Math.round(cours[cours.length - 2][1] * 100) / 100;
                  coursJour[echeanceDefault] = {
                      date: 'Cours au ' + new Date(coursLast[0] * 1000).toLocaleDateString(),
                      cours: coursLastVal,
                      isExpire: echeanceDefault < coursData.current,
                      diff: cousDiffVal,
                      cloture: coursLastVal - cousDiffVal,
                      isLiveDiff: true
                  };
                }
            }
            return coursJour;
        },
        getCoursJourInfos(coursName, echeance, coursData, live, isExpire) {
            const cultCode = coursName + '_' + echeance;
            const cours = coursData[echeance];
            if (!cours) {
                return null;
            }
            var lastIndex = cours.length - 1;
            let coursLastVal = live[cultCode];
            let cousDiffVal = coursLastVal - cours[lastIndex][1];
            let isLiveDiff = true;
            if (!coursLastVal) {
                coursLastVal = cours[lastIndex][1];
                cousDiffVal = coursLastVal - cours[lastIndex - 1][1];
                if(live.date){
                  isLiveDiff = false;
                }
            }

            return {
                date: cours[lastIndex][0] * 1000,
                cours: coursLastVal,
                isExpire: isExpire,
                diff: cousDiffVal,
                isLiveDiff: isLiveDiff,
                cloture: coursLastVal - cousDiffVal,
                max: live.max[cultCode],
                min: live.min[cultCode]
            }
        },
        getCoursSuffix(coursName) {
          return this.referentiel.cours[coursName].libelle_cours.replace('Rendu ', '').replace('Fob ', '');
        },
        getCoursDate(date, isExpire, dateLive, now) {
            if (isExpire) {
                return 'cours au ' + new Date(date).toLocaleDateString();
            }
            if (dateLive) {
                date = new Date(dateLive * 1000);
                var dateNow = new Date(now);
                if (dateNow - date < 50 * 60 * 1000) {
                    return 'mis à jour il y a ' + Math.round((dateNow - date) / (60 * 1000)/5)*5 + 'min';
                } else {
                    return 'mis à jour à ' + date.getHours() + 'h' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
                }
            } else {
                return 'cours de clôture au ' + new Date(date).toLocaleDateString();
            }
        },
        formatCoursDiff(diff) {
          return (diff > 0 ? '+' : '') + diff.toLocaleString('fr', { minimumFractionDigits: 2 });
        },
        getLabelEcheance(echeance) {
            return this.monthsShort[echeance % 100 - 1] + ' ' + parseInt(echeance / 100) % 100;
        },
        getCultureFromList(cultures, refCulture, refDestination){
          for (let i = 0; i < cultures.length; i++) {
            const cult = cultures[i];
            if (cult.ref_culture == refCulture && cult.ref_destination == refDestination) {
              return {
                surface: cult.surface < 0.0001 ? '' : cult.surface,
                rendement: cult.rendement
              };
            }
          }
          return null;
        },
        getTonneProd(cult, isQHa){
          let tonne = '';
          if (cult.surface == undefined || cult.surface === '') {
            // RAF
          } else {
            if (cult.rendement == undefined || cult.rendement === '') {
              // RAF
            } else {
              let rdt = cult.rendement / (isQHa ? 10 : 1);  
              if (rdt < 0.0001) {
                tonne = 0;
              } else {
                tonne = cult.surface * rdt;
              }
            }
          }
          if (tonne){
            if (tonne > 50) {
              tonne = Math.round(tonne / 10)*10;
            } else if(tonne > 10) {
              tonne = Math.round(tonne);
            } else if(tonne > 1) {
              tonne = Math.round(tonne * 10)/10;
            } else {
              tonne = Math.round(tonne * 100)/100;
            }
          }
          return tonne;
        },
        getTonneTotal(cultures, refCulture, refDestination, tonne_vendre, cult) {
          let tonne = tonne_vendre;
          if (tonne == undefined || tonne === '') {
            if(! cult){
              cult = this.getCultureFromList(cultures, refCulture, refDestination);
            }
            if(cult){
              tonne = this.getTonneProd(cult);
            }
          }
          if(tonne){
            Math.round(tonne * 1000) / 1000;
          }
          return tonne;
        },
        getTonneTotalClient(clientConnectInfos) {
          return this.getTonneTotal([], null, null, clientConnectInfos.tonne, clientConnectInfos);
        },
        getTonneVendu(ventes, clientId, isPrixMoyen, isCA) {
          return ventes.reduce(function (sum, vente) {
              if(clientId && vente.client != clientId){
                // RAF
              } else if((isPrixMoyen && vente.prix === '') || (! isPrixMoyen && vente.is_ignore)){
                // RAF
              } else if(isCA){
                sum += vente.prix * vente.tonne;
              } else {
                sum += vente.tonne;
              }
              return sum;
            }, 0);
        },
        getPrixMoyen(ventes, clientId) {
          const ca = this.getTonneVendu(ventes, clientId, true, true);
          return ca ? Math.round(ca / this.getTonneVendu(ventes, clientId, true)) : 0;
        },
        getMissingConfig(negoce) {
          for (let i = 0; i < negoce.length; i++) {
            var negoceItem = negoce[i];
            if (negoceItem.prix[this.campagne]){
              for (const refCulture in this.user.ventes) {
                if(negoceItem.prix[this.campagne][refCulture]){
                  for (const refDestination in this.user.ventes[refCulture]) {
                    if(negoceItem.prix[this.campagne][refCulture][refDestination]) {
                      var userConfig = this.user.ventes[refCulture][refDestination].config;
                      var isConfig = this.isConfig(negoceItem.config, this.campagne, refCulture, refDestination);
                      if(isConfig && ! (userConfig && userConfig[negoceItem.id])){
                        return {
                          negoceId: negoceItem.id,
                          refCulture: refCulture,
                          refDestination: refDestination,
                        };
                      }
                    }
                  }
                }
              }
            }
          }
        },
        isConfig(config, campagne, refCulture, refDestination){
          for (let j = 0; j < config.length; j++) {
            var configItem = config[j];
            if(configItem.campagne && configItem.campagne != campagne){
              continue;
            }
            if(configItem.refCulture && configItem.refCulture != refCulture){
              continue;
            }
            if(configItem.refDestination && configItem.refDestination != refDestination){
              continue;
            }
            return true;
          }
          return false;
        },
        isConfigValid(prixConfig, itemConfig, clientConfig){
          if(prixConfig){
            if(itemConfig !== null){
              if(! itemConfig){
                itemConfig = {};
              }
              if(! itemConfig.stockage){
                itemConfig = JSON.parse(JSON.stringify(itemConfig));
                itemConfig.stockage = ['os'];
              }
            }
            for (const key in prixConfig) {
              if(itemConfig && itemConfig[key]){
                if(! itemConfig[key].includes(prixConfig[key])){
                  return false;
                }
              } else if(clientConfig && clientConfig[key]){
                if(! clientConfig[key].includes(prixConfig[key])){
                  return false;
                }
              }
            }
          }
          return true;
        },
        getPrixNegoce(negoce, refCulture, refDestination, campagne) {
          var prix = [];
          for (let i = 0; i < negoce.length; i++) {
            var negoceItem = negoce[i];
            prix.push({
              id: negoceItem.id,
              label: negoceItem.label,
              label_appro: negoceItem.label_appro,
              tc: negoceItem.tc,
              tc_appro: negoceItem.tc_appro,
              date: negoceItem.date,
              non_dispo: negoceItem.non_dispo,
              tel: negoceItem.tel,
              tel_appro: negoceItem.tel_appro,
              prix_max: negoceItem.prix_max,
              is_config: campagne && this.isConfig(negoceItem.config, campagne, refCulture, refDestination),
              list: this.getListPrix(negoceItem, refCulture, refDestination).filter(value => {return ! value.hide; })
            });
          }
          return prix;
        },
        getListPrix(negoceItem, refCulture, refDestination) {
          var type = 'prix';
          if(refCulture == 'appros'){
            type = 'appros';
            refCulture = refDestination;
          }
          if (  negoceItem
            &&  negoceItem[type]
            &&  negoceItem[type][this.campagne]
            &&  negoceItem[type][this.campagne][refCulture]
            && (type == 'appros' || negoceItem[type][this.campagne][refCulture][refDestination])) {
              if(type == 'appros'){
                return negoceItem[type][this.campagne][refCulture];
              } else {
                return negoceItem[type][this.campagne][refCulture][refDestination];
              }
           } else {
             return [];
           }
        },
        filterListPrix(list, config){
          var listFilter = [];
          for (let i = 0; i < list.length; i++) {
            var item = list[i];
            if(this.isConfigValid(item.config, null, config)){
              listFilter.push(item);
            }
          }
          return listFilter;
        },
        maxListPrix(list){
          var listMax = {};
          for (let i = 0; i < list.length; i++) {
            var item = list[i];
            if(! listMax[item.label] || (item.cours > listMax[item.label].cours)){
              listMax[item.label] = item;
            }
          }
          return Object.values(listMax);
        },
        getListMois(campagne) {
            var list = []
            var now = new Date();
            var annee = now.getFullYear();
            var anneeMin = Math.min(annee - 1, campagne - 1);
            var initMonth = now.getMonth();
            do {
              for (let m = initMonth; m >= 0; m--) {
                list.push({
                  value: (m < 9 ? '0' : '') + (m + 1) + '/' + annee,
                  label: this.monthsLong[m] + ' ' + annee
                });
              }
              annee -= 1;
              initMonth = 11;
            } while (annee >= anneeMin);
            return list;
        },
        sortCultList(list) {
            list.sort(function(a, b){
              var aIndex = this.referentiel.cultures[a.refCulture].destinations[a.refDestination].index;
              var bIndex = this.referentiel.cultures[b.refCulture].destinations[b.refDestination].index;
                if(aIndex || bIndex){
                  if(aIndex && (! bIndex || aIndex < bIndex)){
                    return -1;
                  } else {
                    return 1;
                  }
                } else if(a.refCulture > b.refCulture){
                  return 1;
                } else if (a.refCulture == b.refCulture){
                  var listDest = Object.keys(this.referentiel.cultures[a.refCulture].destinations);
                  return listDest.indexOf(a.refDestination) > listDest.indexOf(b.refDestination) ? 1 : -1;
                } else {
                  return -1;
                }
            }.bind(this));
            var sortCultList = ['colza', 'mais', 'ble_tendre'];
            for (let i = 0; i < sortCultList.length; i++) {
                const sortCult = sortCultList[i];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].refCulture == sortCult && list[i].refDestination == 'conso') {
                        list.splice(0, 0, list.splice(i, 1)[0]);
                    }
                }
            }            
        },
        getCultLabel(refCulture, refDestination){
          if(! (refCulture && refDestination)){
            refCulture = this.refCulture;
            refDestination = this.refDestination;
          }
          if(refCulture == 'appros'){
            return this.referentiel.libelles.appros[refDestination];
          } else if(this.referentiel.cultures[refCulture].destinations[refDestination].libelle){
            return this.referentiel.cultures[refCulture].destinations[refDestination].libelle;
          } else {
            return this.referentiel.cultures[refCulture].libelle + ' - ' + this.referentiel.libelles.destinations[refDestination];
          }
        },
        callClient(venteClient, clientInfos, trackInfos) {
          this.sendTrackEvent('client call ' + venteClient + ' ' + trackInfos);
          this.$callTel(clientInfos.tel);
        },
        addVenteHash(body) {
          var id = JSON.stringify({
            campagne: this.campagne,
            ref_culture: body.ref_culture,
            ref_destination: body.ref_destination,
            client: body.data.client,
            negoce: body.data.negoce,
            id_prix: body.data.id_prix,
            label_prix: body.data.label_prix,
            prix: body.data.prix,
            tonne: body.data.tonne
          });
          var hash = 0;
          for (let i = 0, len = id.length; i < len; i++) {
              let chr = id.charCodeAt(i);
              hash = (hash << 5) - hash + chr;
              hash |= 0; // Convert to 32bit integer
          }
          body.hash_vente = (body.id_vente ? body.id_vente : '') + 'hash' + hash;
        },
        async sendOTP(body, isOffline) {
          this.addVenteHash(body);
          if(this.negoceInfos.is_tech){
            body.is_tech = true;
          }
          if(this.otp.isResend){
            body.is_resend = true;
            this.otp.isResend = false;
          }
          let callPath = this.getPath('/negoce/otp');
          if(isOffline){
            body.timestamp = parseInt(new Date().getTime() / 1000);
            this.$emit('call-api', {
              call: {
                path: callPath,
                data: body,
                isBgFetch: true
              }
            });
          } else {
            const fetchInit = this.$getFetchInit();
            fetchInit.body = JSON.stringify(body);
            callPath = this.$apiDomain + callPath;
            try {
              const response = await this.handleRequest(callPath, fetchInit);
              if(response.user){
                this.updateUserFromResponse(response.user);
                return response;
              } else if(response.isOTPresend){
                this.isShow.otpResend = true;
              }
            } catch(error) {
              this.handleError(error);
              return { error: error };
            }
          }
        },
        resendOTP() {
          this.otp.isResend = true;
          this.isShow.otp = false;
          this.isShow.otpResend = false;
          this.saveVente();
        },
        getClientContact(clientInfos) {
          if(! clientInfos){
            return 'n.c.';
          }
          var contact = {
            type: [],
            value: [],
            join: 'à'
          };
          if(clientInfos.tel){
            contact.type.push('SMS');
            contact.value.push(clientInfos.tel);
            contact.join = 'au';
          }
          if(clientInfos.email){
            contact.type.push('email');
            contact.value.push(clientInfos.email);
          }
          return contact.type.join('/') + ' ' + contact.join + ' ' + contact.value.join(' / ');
        },
        getClientConnectInfos(clientId, ventes, refCulture, refDestination){
          if(clientId){
            if(refCulture && refDestination){
              if(ventes[refCulture][refDestination].clients
              && ventes[refCulture][refDestination].clients[clientId]){
                  return ventes[refCulture][refDestination].clients[clientId];
              }
            } else {
              if(ventes.clients && ventes.clients[clientId]){
                return ventes.clients[clientId];
              }
            }
          }
          return {};
        },
        getClientInfosTech(clients, clientId){
          var clientInfos = clients[clientId];
          if(! clientInfos){
            for (const id in clients) {
              const clientItem = clients[id];
              if(clientItem.id_user == clientId){
                return clientItem;
              }
            }
          }
          return clientInfos; // can be undefined
        },
        redirectContrat(idVente) {
          let path = [];
          path.push(this.refCulture);
          path.push(this.refDestination);
          path.push(idVente);
          this.$emit('change-multi', {
            idMulti: this.user.id,
            initPath: this.user.id + '/v/' + path.join('/')
          });
        },
        displayIdVente(idVente){
          return idVente.toString().replace(/^[a-z]{3}([0-9]*-)?/, '')
        },
        getContratInfos(type, isTech){
          var infos;
          if(! this.vente.id){
            return null;
          }
          if(this.isTech || isTech){
            if(this.clientInfos && this.clientInfos.ral){ 
              infos = this.clientInfos.ral[this.vente.id.toString()];
            }
          } else if(this.data.negoce && this.data.negoce.ral) {
            infos = this.data.negoce.ral[this.vente.id.toString()];
          }
          if(infos){
            if(type == 'reste' && infos.ral != undefined){
              return {
                ral: infos.ral,
                raf: infos.raf,
              };
            }
            if(type == 'link'){
              return infos.link;
            }
          }
          return null;
        },
        setVente(vente) {
          this.setJson(this.vente, vente);
          if(this.vente.prix === '' && vente.base != undefined){
            this.vente.prix = vente.base;
          }
        },
        getDateLabelFromIso(date) {
          var dateArray = date.split('-');
          return dateArray.pop() + ' ' + this.monthsShort[dateArray.pop() - 1] + ' ' + dateArray.pop();
        },
        getDateLabelFromFr(date) {
          var dateArray = date.split('/');
          var label = dateArray.pop();
          label = this.monthsShort[dateArray.pop() - 1] + ' ' + label;
          if (dateArray.length) {
            label = dateArray.pop() + ' ' + label;
          }
          return label;
        }
    }
}